import React from 'react'
import styled from 'styled-components'
import { Moment } from 'moment'

import { color } from 'styles/colors'
import { screenSize } from 'styles/shared'

import AlertCard from 'pages/HehmDevice/Alerts/AlertCard'

import { Alert } from 'types/Alert'

type Props = {
  alerts: Array<Alert>
  headerType?: string
  showDayRthCallback: (day: Moment) => void
}
const AlertsList = ({ alerts, headerType = 'ActiveAlerts', showDayRthCallback }: Props) => {
  return (
    <S.Grid headerType={headerType}>
      {alerts?.map((alert, index) =>
        (
          <S.Card key={alert.id}>
            <AlertCard
                alertNumber={index + 1}
                alert={alert}
                showDayRthCallback={showDayRthCallback}
            />
          </S.Card>
        )
      )}
    </S.Grid>
  )
}

export default AlertsList

const S = {
  Grid: styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'headerType'
  })<{ headerType: string }>`
    display: grid;
    grid-template-columns: ${props => props.headerType === 'AlertHistory' ? 'repeat(3, 1fr)' : 'repeat(2, 1fr)'};
    gap: 16px;
    align-items: start;
    grid-auto-rows: min-content;
    @media ${screenSize.large} {
      grid-template-columns: repeat(2, 1fr);
    }
    @media ${screenSize.medium} {
      display: flex;
      flex-direction: column;
    }
  `,
  Card: styled.div`
    flex: 1;
    border: 1px solid ${color('border')};
    border-radius: 10px;
    width: 100%;
  `
}
